import { render, staticRenderFns } from "./questionnaireList.vue?vue&type=template&id=28fd273a&scoped=true"
import script from "./questionnaireList.vue?vue&type=script&lang=js"
export * from "./questionnaireList.vue?vue&type=script&lang=js"
import style0 from "./questionnaireList.vue?vue&type=style&index=0&id=28fd273a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fd273a",
  null
  
)

export default component.exports